export class RequestServiceablePostModel {
  public RequestId?: number;
  public ShipmentTypeId?: number;
  public Pn?: string;
  public Sn?: string;
  public Awb?: string;
  public FlightNo?: string;
  public CarrierEnum?: number;
  public FlightDate?: Date;
  public RequestedDeliveryDate?: Date;
  public EstimatedDeliveryDate?: Date;
  public Status?: Number;
  public ShippingInvoice?: string;
  public ShippingTypeEnum?: number;
  public SubmittedBy?: string;
  public SubmittedDate?: Date;
}

export class RequestServiceablePutModel {
  public id?: number;
  public RequestId?: number;
  public ShipmentTypeId?: number;
  public Pn?: string;
  public Sn?: string;
  public Awb?: string;
  public FlightNo?: string;
  public CarrierEnum?: number;
  public FlightDate?: Date;
  public RequestedDeliveryDate?: Date;
  public EstimatedDeliveryDate?: Date;
  public Status?: Number;
  public ShippingInvoice?: string;
  public ShippingTypeEnum?: number;
  public SubmittedBy?: string;
  public SubmittedDate?: Date;
  public updatedBy?: string;
  public updatedDate?: Date;
}
